/* eslint-disable react/require-default-props */
import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { Container } from './styles';

registerLocale('pt-BR', ptBR);

interface AiManagementDatetimePickerProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  withTime?: boolean;
  disabled?: boolean;
}

const AiManagementDatetimePicker: React.FC<AiManagementDatetimePickerProps> = ({
  id,
  value,
  onChange,
  withTime = true,
  disabled = false,
}) => {
  const valueFormat = withTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD';

  return (
    <Container>
      <DatePicker
        id={id}
        selected={value ? moment(value, valueFormat).toDate() : null}
        onChange={(date) => onChange(date ? moment(date).format(valueFormat) : '')}
        showTimeSelect={withTime}
        locale="pt-BR"
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="Hora"
        dateFormat={withTime ? 'Pp' : 'P'}
        placeholderText={withTime ? 'dd/mm/aaaa hh:mm' : 'dd/mm/aaaa'}
        className="form-control"
        wrapperClassName="d-block"
        popperPlacement="bottom-end"
        isClearable
        clearButtonTitle="Limpar"
        disabled={disabled}
      />
    </Container>
  );
};

export default AiManagementDatetimePicker;
